import { useNavigate, useLocation } from 'react-router-dom';
import { useTrip } from '@trip-planner-monorepo/shared';
import {
  FiCalendar,
  FiMapPin,
  FiNavigation,
  FiHome,
  FiGrid,
  FiFileText
} from 'react-icons/fi';
import './BottomNav.css';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedTripId } = useTrip();

  const getCurrentSection = () => {
    const path = location.pathname;
    if (path.includes('/places')) return 'places';
    if (path.includes('/travel')) return 'travel';
    if (path.includes('/accommodation')) return 'accommodation';
    if (path.includes('/extras')) return 'extras';
    if (path.includes('/documents')) return 'documents';
    if (path.includes('/trips/') && !path.includes('/places') &&
      !path.includes('/travel') && !path.includes('/accommodation') &&
      !path.includes('/extras') && !path.includes('/documents')) return 'days';
    return '';
  };

  const handleNavigation = (section) => {
    if (!selectedTripId) {
      if (location.pathname !== '/') {
        navigate('/');
      }
      return;
    }

    if (section === 'days') {
      navigate(`/trips/${selectedTripId}`);
    } else if (
      section === 'places' ||
      section === 'travel' ||
      section === 'accommodation' ||
      section === 'extras' ||
      section === 'documents'
    ) {
      navigate(`/trips/${selectedTripId}/${section}`);
    }
  };

  const currentSection = getCurrentSection();

  return (
    <nav className="bottom-nav-container">
      <div className="bottom-nav-island">
        <button
          className={`nav-btn ${currentSection === 'days' ? 'active' : ''}`}
          onClick={() => handleNavigation('days')}
        >
          <FiCalendar className="nav-icon days-icon" />
          <span>Days</span>
        </button>
        <button
          className={`nav-btn ${currentSection === 'places' ? 'active' : ''}`}
          onClick={() => handleNavigation('places')}
        >
          <FiMapPin className="nav-icon places-icon" />
          <span>Places</span>
        </button>
        <button
          className={`nav-btn ${currentSection === 'travel' ? 'active' : ''}`}
          onClick={() => handleNavigation('travel')}
        >
          <FiNavigation className="nav-icon travel-icon" />
          <span>Travel</span>
        </button>
        <button
          className={`nav-btn ${currentSection === 'accommodation' ? 'active' : ''}`}
          onClick={() => handleNavigation('accommodation')}
        >
          <FiHome className="nav-icon accommodation-icon" />
          <span>Accommodation</span>
        </button>
        <button
          className={`nav-btn ${currentSection === 'documents' ? 'active' : ''}`}
          onClick={() => handleNavigation('documents')}
        >
          <FiFileText className="nav-icon docs-icon" />
          <span>Docs</span>
        </button>
        <button
          className={`nav-btn ${currentSection === 'extras' ? 'active' : ''}`}
          onClick={() => handleNavigation('extras')}
        >
          <FiGrid className="nav-icon extras-icon" />
          <span>Extras</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;